export enum EModalStatus {
  GetVerificationCode = 'GetVerificationCode',
  SendVerificationCode = 'SendVerificationCode',
  Error = 'Error',
}

export interface IPageState {
  isWebview?: boolean;
  stickyScrollBtnVisible: boolean;
  modals: {
    isOpen: boolean;
    status: EModalStatus;
    action: 'copy' | 'share' | null;
    error: string;
  };
  referralLinkFallbackModal: {
    isOpen: boolean;
    referralLink: string;
  };
}
